import axiosPost from '../axiosPost';

export const monedasDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "MonedaDel",
        "params": {
            "monedaId": id
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}